import React, {Fragment, useState, useRef, useEffect} from 'react';
import '../Orders/orders.css';
import {translate} from "../../utils/utils";
import userStore from "../../stores/userStore";

import {Switcher} from "./form-control";
import {Label} from "reactstrap";

const translateActionName = (typeName) => {
    let key = null;
    switch (typeName) {
        case 'download':
            key = 'common.documents.downloadActionTitle';
            break;
        case 'send-email':
            key = 'common.documents.sendEmailActionTitle';
            break;
        case 'update':
            key = 'common.documents.updateActionTitle';
            break;
        case 'rename':
            key = 'common.documents.renameActionTitle';
            break;
        case 'remove':
            key = 'deliveryOrders.orderBlock.orderActions.delete';
            break;
        case 'upload':
            key = 'common.documents.uploadActionTitle';
            break;
        case 'details':
            key = 'deliveryOrders.orderBlock.orderActions.details';
            break;
        case 'edit':
            key = 'deliveryOrders.orderBlock.orderActions.edit';
            break;
        case 'subscribe':
            key = 'deliveryOrders.orderBlock.orderActions.getNotifications';
            break;
        case 'editLogistic':
            key = 'deliveryOrders.orderBlock.orderActions.editLogistic';
            break;
        case 'editOwner':
            key = 'deliveryOrders.orderBlock.orderActions.changeOwner';
            break;
       /* case 'editManager':
            key = 'deliveryOrders.orderBlock.orderActions.changeManager';
            break;*/
        case 'moveToCalculation':
            key = 'deliveryOrders.orderBlock.orderActions.moveToCalculation';
            break;
        case 'update':
            key = 'person.calculationInfo.update';
            break;
       /* case 'openHistoryChanges':
            key = 'deliveryOrders.historyChanges.modal.title'
            break;*/
        case 'copyOrderDeliveryRequestGroup':
            key='deliveryOrders.orderBlock.orderActions.copyOrderDeliveryRequestGroup'
            break;
        case 'changeGroupClient':
            key='user.actions.changeGroupClient'

    }

    return key? translate({ id: key}): '-';
};

const useOutsideAlerter = (ref, act) => {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                if(act && typeof act === 'function'){
                    act();
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
};

function ActionMenu({actions, itemId, callback, isBlock}) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const useToggle = actions.some(x => x.useToggle);
    const [hoverClass, setHover] = useState(null);
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, () => setIsMenuOpen(false));
    const onClick = actions && actions[0]? () => {setIsMenuOpen(!isMenuOpen)}: () => {};

    const getHoverSelectedClass = (type) => {
        if (type === hoverClass) {
            return `agora-action-logo-hover-${hoverClass}`;
        }
    };

    if(isBlock === true){
        return (
            <div className={useToggle ? 'agora-actions with-toggle' : 'agora-actions'} style={{position:"relative"}}>
                {
                    actions.map((x, ind) => {
                        const item = <div key={ind}
                                          onClick={() => {
                                              if (x.onClick && typeof x.onClick === 'function') {
                                                  x.onClick(itemId, callback);
                                                  setIsMenuOpen(false);
                                              }
                                          }
                                          }>
                            <div
                                className={`agora-action-logo agora-action-logo-${x.type} ${getHoverSelectedClass(x.type)}`}></div>
                            <div onMouseOver={() => setHover(x.type)} onMouseLeave={() => setHover('')}>
                                {translateActionName(x.type)}
                            </div>
                            {x.useToggle && <div>
                                <Switcher
                                    onChange={x.onChange}
                                    checked={x.checked}
                                    className="mr-3"
                                />
                            </div>}

                        </div>
                        return x.type !== 'upload' ? item : (
                            <Fragment>
                                <input
                                    id={'load-file-private-another'}
                                    name="file"
                                    type="file"
                                    className="d-none"
                                    onChange={(e) => {
                                        if (x.onCreateDoc && typeof x.onCreateDoc === 'function') {
                                            x.onCreateDoc(e, x.fileKey || 'ANOTHER', '', x.formatName);
                                            setIsMenuOpen(false);
                                        }
                                    }}
                                />
                                <Label
                                    for={'load-file-private-another'}
                                >
                                    {item}
                                </Label>
                            </Fragment>
                        );

                    })
                }

            </div>
        )
    }

    return (
        <div className={'agora-actions-btn'}>
            <div className={'agora-actions-btn_icon'} onClick={onClick}></div>
            {
                isMenuOpen && (
                    <div className={useToggle ? 'agora-actions with-toggle' : 'agora-actions'} ref={wrapperRef}>
                        {
                            actions.map((x, ind) => {
                                const item = <div key={ind}
                                                  onClick={() => {
                                                      if (x.onClick && typeof x.onClick === 'function') {
                                                          x.onClick(itemId, callback);
                                                          setIsMenuOpen(false);
                                                      }
                                                  }
                                                  }>
                                    <div
                                        className={`agora-action-logo agora-action-logo-${x.type} ${getHoverSelectedClass(x.type)}`}></div>
                                    <div onMouseOver={() => setHover(x.type)} onMouseLeave={() => setHover('')}>
                                        {translateActionName(x.type)}
                                    </div>
                                    {x.useToggle && <div>
                                        <Switcher
                                            onChange={x.onChange}
                                            checked={x.checked}
                                            className="mr-3"
                                        />
                                    </div>}

                                </div>
                                return x.type !== 'upload' ? item : (
                                    <Fragment>
                                        <input
                                            id={'load-file-private-another'}
                                            name="file"
                                            type="file"
                                            className="d-none"
                                            onChange={(e) => {
                                                if (x.onCreateDoc && typeof x.onCreateDoc === 'function') {
                                                    x.onCreateDoc(e, x.fileKey || 'ANOTHER', '', x.formatName);
                                                    setIsMenuOpen(false);
                                                }
                                            }}
                                        />
                                        <Label
                                            for={'load-file-private-another'}
                                        >
                                            {item}
                                        </Label>
                                    </Fragment>
                                );

                            })
                        }

                    </div>
                )
            }
        </div>
    );
}


export {
    ActionMenu
};
